<template>
  <div>
    <div class="p-2">
      <div class="row">
        <div class="col-md-6">
          <div>
            <h3>بيان كشف حساب مختصر للحرفي</h3>
            <table>
              <tr>
                <td>الحرفي</td>
                <td v-if="workerDeal.worker">{{ workerDeal.worker.name }}</td>
              </tr>
              <tr>
                <td>الهاتف</td>
                <td v-if="workerDeal.worker">{{ workerDeal.worker.phone }}</td>
              </tr>
              <tr>
                <td>العنوان</td>
                <td v-if="workerDeal.worker">
                  {{ workerDeal.worker.address }}
                </td>
              </tr>
              <tr>
                <td>المشروع</td>
                <td v-if="workerDeal.project">{{ workerDeal.project.name }}</td>
              </tr>
              <tr>
                <td>وصف المشروع</td>
                <td v-if="workerDeal.project">
                  {{ workerDeal.project.description }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-row-reverse flex-wrap gap-3">
            <div class="worker-card">
              <div>
                <div class="d-flex flex-column gap-1">
                  <h6 class="font-bold reminder">المتبقي</h6>
                  <div>
                    <h6>
                      {{
                        workerDeal.amount - workerDeal.paied > 0
                          ? workerDeal.amount - workerDeal.paied
                          : 0
                      }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>

            <div class="worker-card">
              <div>
                <div class="d-flex flex-column gap-1">
                  <h6 class="font-bold paied">المدفوع</h6>
                  <div>
                    <h6>{{ workerDeal.paied }}</h6>
                  </div>
                </div>
              </div>
            </div>

            <div class="worker-card">
              <div>
                <div class="d-flex flex-column gap-1">
                  <div>
                    <h6 class="font-bold total">إجمالي الاتفاقيات</h6>
                  </div>
                  <div>
                    <h6>{{ workerDeal.amount }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <table>
        <tr>
          <td>#</td>
          <td>المبلغ</td>
          <td>التعليق</td>
          <td>الإنشاء</td>
        </tr>
        <tr v-for="(payment, index) in workerDeal.payments" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ payment.amount }}</td>
          <td>{{ payment.description }}</td>
          <td>{{ $moment(payment.created_at).locale("ar").format("LLL") }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
// import { ipcRenderer } from "electron";
// window.ipcRenderer = ipcRenderer;

export default {
  data() {
    return {
      workerDeal: {},
    };
  },
  mounted() {
    // ipcRenderer.on("print_worker_deals", (e, data) => {
    //   this.workerDeal = data;
    //   ipcRenderer.send("printWorkerDeals");
    // });
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 15px !important;
  span {
    font-size: 20px !important;
  }
}

.worker-card {
  padding: 15px 25px;
  h6 {
    font-size: 13px;
    text-align: center !important;
  }
}

table {
  width: 100%;
  margin-top: 10px;
  border: 1px solid #333;
  tr,
  td {
    border: 1px solid #333;
    padding: 5px;
  }
}
</style>
